import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';

import ChartTitle from '../../ChartTitle/ChartTitle';

import { trapActivityLineChartOptions } from './chartOptions';

import { useChartData } from 'hooks/Analitics/MCTCharts/2_trapsActivityLineChart/useChartStates';
import { TrapType } from 'components/AnalyticsPage/TrapType';
import { ObjectTraps } from 'api/analitics/types';
import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';

interface ChartProps {
  slug: string;
  type: TrapType;
  objectTraps: ObjectTraps;
}

const TrapsActivityLineChart: React.FC<ChartProps> = ({ slug, type, objectTraps }) => {
  const [trapType, setTrapType] = useState<TrapType>(type);
  const [isBarChart, setIsBarChart] = useState<boolean>(false);
  const { period, startDate, endDate, showCustom, chartData, handlePeriodChange, setStartDate, setEndDate } =
    useChartData({ slug, trapType: trapType });
  const { t } = useTranslation();
  const isMobile = useMediaQuery(MediaBreakpoints.mobile);
  const chartOptions = trapActivityLineChartOptions(chartData, t, isMobile, trapType, isBarChart);

  return (
    <div className="card m-0 border border-2 rounded-4 position-relative h-100">
      <div className="card-header rounded-4">
        <ChartTitle
          title={
            trapType === TrapType.ALL || trapType === TrapType.SRST
              ? t('ChartsAnalitics.all_traps_captures.title')
              : trapType === TrapType.MCT
                ? t('ChartsAnalitics.all_traps_captures.titleMCT')
                : t('ChartsAnalitics.all_traps_captures.titleSMST')
          }
          period={period}
          handlePeriodChange={handlePeriodChange}
          startDate={startDate}
          setStartDate={setStartDate}
          showCustom={showCustom}
          endDate={endDate}
          setEndDate={setEndDate}
          showSetTrapTypeFilter={
            objectTraps?.mct.was_ever_installed && objectTraps?.smst.was_ever_installed && type !== TrapType.SRST
          }
          trapType={trapType}
          setTrapType={(value: TrapType) => setTrapType(value)}
          showSwitchChartType
          isBarChart={isBarChart}
          setIsBarChart={(value: boolean) => setIsBarChart(value)}
        />
      </div>
      <div className="card-body">
        <div className="position-relative">
          <ReactApexChart
            key={isBarChart ? 'bar' : 'area'}
            options={chartOptions}
            series={chartOptions.series}
            type={isBarChart ? 'bar' : 'area'}
            height={350}
          />
        </div>
      </div>
    </div>
  );
};

export default TrapsActivityLineChart;
